import imageSlider from "../components/imageSlider";
import quoteSlider from "../components/quoteSlider";
import sectionParallax from "../components/sectionParallax";

/**
 * Front Page
 */
const PageFrontPage =( $ )=>{

	if ( $( 'body' ).hasClass( 'home' ) ) {
		quoteSlider();
		imageSlider();
		sectionParallax();
	}

};

export default PageFrontPage;
